import React, { useCallback, useState, useRef } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import { handleDataGridExport } from "../../../../common/Utils";
import Toolbar, { Item } from "devextreme-react/toolbar";
import '../../../../common/css/searchPage.css';
import {
  Column,
  DataGrid,
  GroupPanel,
  Scrolling,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Selection,
  Toolbar as GridToolbar,
  Item as GridToolbarItem,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  ColumnHeaderFilter,
} from "devextreme-react/data-grid";

const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];

const SearchLayout = [
  {
    "groupId": 1,
    "fields": [
      {
        "name": "TRANSACTIONTYPE",
        "tableName": "WMTRANSACTIONHEADER",
        "label": "Type",
        "type": "select",
        "options": [],
        "apiUrl": null,
        "grid": null,
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      },    
      {
        "name": "TRANSACTIONNUMBER",
        "tableName": "WMTRANSACTIONHEADER",
        "label": "Transaction #",
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      }
    ]
  },
  {
    "groupId": 2,
    "fields": [
      {
        "name": "R_CUSTOMER",
        "tableName": "WMTRANSACTIONHEADER",
        "label": "Customer",
        "type": "select",
        "options": [""],
        "apiUrl": "",
        "grid": null,
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      }
      ,
      {
        "name": "OpenStatus",
        "tableName": "",
        "label": "",
        "type": "checkboxGroup",
        "options": ["Open Status Only"],
        "apiUrl": null,
        "grid": null,
        "required": false,
        "visible": true,
        "Checked":true
      }
    ]
  },
  {
    "groupId": 3,
    "fields": [
      {
        "name": "STAGE",
        "tableName": "WMTRANSACTIONHEADER",
        "label": "Stage",
        "type": "select",
        "options": [],
        "apiUrl": null,
        "grid": null,
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      }
    ]
  },
  {
    "groupId": 4,
    "fields": [
      {
        "name": "STATUS",
        "tableName": "WMTRANSACTIONHEADER",
        "label": "Status",
        "type": "select",
        "options": [],
        "apiUrl": null,
        "grid": null,
        "required": false,
        "visible": true,
        "isLabelChanged": false,
      }
    ]
  }
];

const initialFormFields = {
  TRANSACTIONTYPE: '',
  TRANSACTIONNUMBER: '',
  R_CUSTOMER: '',
  STAGE: '',
  STATUS: '',
  OpenStatus:["Open Status Only"]
};

var searchFields = initialFormFields;

const WMTransactionDataEntryList = (props) => {
  const dataGrid = useRef(null);
  const history = useHistory();
  var accessToken = props.oidc.user.access_token;
  var currentUser = props.oidc.user;
  const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
  const [formFields, setformFields] = useState(initialFormFields);
  const formRefs = useRef({});
  const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
  const [searchPanelStatus, setSearchPanelStatus] = useState(true);
  const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
  const rowId = useRef(null);
  
  const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
  const gridKey = "cc8f3999-4ded-4896-aa3d-4e822f678f70";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken); }, []);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state); }, []);
  
  const onSelectionChanged = ({ selectedRowsData }) => {
    if (selectedRowsData && selectedRowsData.length == 1) 
    {
      rowId.current = selectedRowsData[0].rowid;
    } 
    else 
    {
      rowId.current = '';
    }

    setIsEditButtonDisabled(!isEditButtonDisabled);
  };

  const handelEditClick = () => {
    const buttonUrl = "/wm/transactiondataentry/edit-transaction?id="+ rowId.current;
    history.push(buttonUrl);
  };

  const selectionChanged = useCallback(
    (e, tg) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      setSearchPanelStatus((prevStatus) => {
        const newStatus = !prevStatus;
        return newStatus;
      });
    },
    [selectedItems, setSelectedItems],
  );

  const handleSearch = (e) => {
    
    e.event.stopPropagation();
    searchFields = formFields;
    dataGrid.current.instance().refresh();
  }

  const handleReset = (e) => {
    e.event.stopPropagation();
    setformFields(initialFormFields);
    searchFields = initialFormFields;
    dataGrid.current.instance().refresh();
  }

  const handleFormLoad = useCallback(() => 
  {
    var transactionTypes = [{ "Rowid": "R", "Code": "Receipt" }, { "Rowid": "S", "Code": "Shipment" }
      , { "Rowid": "A", "Code": "Adjustment" }];
    loadLookupClient("TRANSACTIONTYPE", transactionTypes);
    
    var customerDataSource = new DataSource({
      store: new createStore({
        key: 'id',
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCustomers`,
        onBeforeSend: function(method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });


    loadLookupFromDataSource("R_CUSTOMER", customerDataSource);

    var stages = [{ "Rowid": "P", "Code": "Plan - No Inventory Effect, No Charges" }, { "Rowid": "F", "Code": "Future Order - No Effect On Net Available, No Charges" }
      , { "Rowid": "N", "Code": "Pending - Effects Net Available, No Charges" }, { "Rowid": "R", "Code": "Ready To Receive/Pick/Staged - Effects Available, No Charges" }
      , { "Rowid": "C", "Code": "Completed/Loaded/Put Away/Transferred/Adjusted - Effects Available, Yes, Charges" }];
    loadLookupClient("STAGE", stages);
    var status = [{ "Rowid": "O", "Code": "Open" }, { "Rowid": "H", "Code": "Hold" }, { "Rowid": "L", "Code": "Ready To Commit Later" }
    , { "Rowid": "Z", "Code": "Committed" }];
    loadLookupClient("STATUS", status);
  }, []);

  const loadLookupClient = (name, data) => {

    try 
    {
      const newOptions = data.map(item => ({
          id: item.Rowid,
          name: item.Code
      }));
      if (formRefs.current[name]) {

          formRefs.current[name].instance().option('dataSource', newOptions);
          formRefs.current[name].instance().option('valueExpr', 'id');
          formRefs.current[name].instance().option('displayExpr', 'name');
      } 
    } 
    catch (error) 
    {
      console.error('Error fetching item detail:', error);
    }
  };

  const loadLookupFromDataSource = (name, dataSource) => {
    if (formRefs.current[name]) 
    {
      formRefs.current[name].instance().option('dataSource', dataSource);
      formRefs.current[name].instance().option('valueExpr', 'id');
      formRefs.current[name].instance().option('displayExpr', 'name');
    } 
    else
    {
      console.log('not found control:');
    }
  };
  const isUpdatingRef = useRef(false);
  const handleFieldChange = useCallback((name, value) => {
    
   
  }, []);

  const onContentReady = (e) => {
    if (!e.component._hasLoaded) {
      
      e.component._hasLoaded = true;
      e.component.option("dataSource", createStore({
        key: 'rowid',
        loadParams:
        {
          transactiontype: function ()
          {
            return searchFields.TRANSACTIONTYPE == null ? "" : searchFields.TRANSACTIONTYPE;
          },
          transactionnumber: function ()
          {
            return searchFields.TRANSACTIONNUMBER == null ? "" : searchFields.TRANSACTIONNUMBER;
          },
          customerrowid: function ()
          {
            return searchFields.R_CUSTOMER == null ? "" : searchFields.R_CUSTOMER;
          },
          stage: function ()
          {
            return searchFields.STAGE == null ? "" : searchFields.STAGE;
          },
          status: function ()
          {
            return searchFields.STATUS == null ? "" : searchFields.STATUS;
          },
          openstatus: function ()
          {
            return searchFields.OpenStatus == null ? "" : searchFields.OpenStatus;
          }
        }, 
        loadUrl:   `${window._env_.REACT_APP_APIS}/${data.Transaction.GetTransactionsWithServerSidePaging}`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          };
        },
      }));
    }
  };

  return (
    <div className="search-page-container">
      <div className="search-page-content">
        <div id="accordion" className="search-page-accordion">
            <AccordionReact
              dataSource={searchpanel}
              collapsible={true}
              multiple={false}
              animationDuration={300}
              selectedItems={selectedItems}
              onSelectionChanged={e => {
                if (e.currentTarget === e.target) {
                  selectionChanged(e, e.target);
                }
              }}
              itemTitleRender={() => (
                <Toolbar className="accordian-toolbar">
                  <Item location="before">
                    <div className="title">
                      <h6
                        style={{
                          color: window._env_.Color2
                        }}
                      >
                        Enter Your Query For WM Transactions
                      </h6>
                    </div>
                  </Item>
                  <Item location="after">
                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default"/>
                  </Item>
                  <Item location="after">
                    <Button className="accordianButton" onClick={handleReset} text="Reset"/>
                  </Item>
                </Toolbar>
              )}
              itemRender={(itemProps) => (
                <FormField
                  currrentUser={currentUser}
                  layoutId='58dfc264-a700-4e77-ae3f-8431b1b92c56'
                  layoutName='WMTransactionDataEntrySearchForm'
                  defaultFormSchema={SearchLayout}
                  formFields={formFields}
                  setformFields={setformFields}
                  handleFieldValueChange={handleFieldChange}
                  DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                  formRefs={formRefs}
                  onFormLoad={handleFormLoad}
                  noSpacingBeforeFirstRow={true}
                />
              )}
              id="accordion-container" 
              className="accordion-height"
            />
          </div>
          <div className="search-page-grid-container">
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
              ref={dataGrid}
              allowColumnReordering={true}
              allowColumnResizing={true}
              onContentReady={(e) => onContentReady(e)} 
              showBorders={true}
              hoverStateEnabled={true}
              onSelectionChanged={(e) => onSelectionChanged(e)}
              remoteOperations={true}
              searchEnabled={true}
              columnAutoWidth={true}
              className="search-page-grid"
            >
                  <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                  >
                    <ColumnChooserSearch
                      enabled={true}
                      editorOptions={{ placeholder: 'Search column' }} />
                  </ColumnChooser>
                  <ColumnHeaderFilter />
                  <Export enabled={true} allowExportSelectedData={true} />
                  <Selection mode="multiple" />
                  <Sorting visible={true} mode="multiple" />
                  <Paging defaultPageSize={10} />
                  <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                  />
                  <FilterPanel visible={true}  />
                  <HeaderFilter enabled={true} visible={false} />
                  <GroupPanel visible={true} />
                  <Grouping autoExpandAll={false} />
                  <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                  />
                  <FilterRow visible={true} children={false} />
                  <HeaderFilter visible={true} />
                  <Column dataField="transactionnumber" caption="Transaction #"></Column>
                  <Column
                    dataField="customer"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.R_CUSTOMER', 'Customer')}
                  ></Column>
                  <Column
                    dataField="transactiondate"
                    dataType="date"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.TRANSACTIONDATE', 'Trans Date')}
                    headerFilter={{
                      groupInterval: null,
                      search: { enabled: false }
                    }}
                  ></Column>
                  <Column
                    dataField="actualreceivedshippeddatetime"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.ACTUALRECEIVEDSHIPPEDDATETIME', 'Recv/Ship Dt')}
                    dataType="date"
                    format="MM/dd/yyyy hh:mm:ss aa"
                    headerFilter={{
                      groupInterval: null,
                      search: { enabled: false }
                    }}
                  ></Column>
                  <Column dataField="shipper" caption={Localization.formatMessage('WMTRANSACTIONHEADER.R_SHIPPER', 'Shipper ID')}></Column>
                  <Column dataField="status" caption={Localization.formatMessage('WMTRANSACTIONHEADER.STATUS', 'Status')}></Column>
                  <Column dataField="stage" caption={Localization.formatMessage('WMTRANSACTIONHEADER.STAGE', 'Stage')}></Column>
                  <Column dataField="shipperbolnumber" caption={Localization.formatMessage('WMTRANSACTIONHEADER.SHIPPERBOLNUMBER', 'Shipper BOL #')} visible={false}></Column>
                  <Column dataField="reference" caption={Localization.formatMessage('WMTRANSACTIONHEADER.REFERENCE', 'Reference')} visible={false}></Column>
                  <Column
                    dataField="shipperName"
                    caption="Shipper Name"
                    visible={false}
                  ></Column>
                  <Column dataField="pallets" caption="Pallets" visible={false}></Column>
                  <Column dataField="comment" caption={Localization.formatMessage('WMTRANSACTIONHEADER.COMMENT', 'Comment')} visible={false}></Column>
                  <Column
                    dataField="userdefinedcode1"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_1', 'Code 1')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedcode2"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_2', 'Code 2')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedcode3"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_3', 'Code 3')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedcode4"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_4', 'Code 4')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedcode5"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_5', 'Code 5')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedcode6"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_6', 'Code 6')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedcode7"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_7', 'Code 7')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedcode8"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_8', 'Code 8')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedcode9"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_9', 'Code 9')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedcode10"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCODE_10', 'Code 10')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedreference1"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_1', 'Reference 1')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedreference2"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_2', 'Reference 2')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedreference3"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_3', 'Reference 3')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedreference4"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_4', 'Reference 4')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedreference5"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_5', 'Reference 5')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedreference6"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_6', 'Reference 6')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedreference7"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_7', 'Reference 7')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedreference8"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_8', 'Reference 8')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedreference9"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_9', 'Reference 9')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedreference10"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_10', 'Reference 10')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefineddate1"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_1', 'Date 1')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefineddate2"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_2', 'Date 2')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefineddate3"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_3', 'Date 3')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefineddate4"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_4', 'Date 4')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefineddate5"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_5', 'Date 5')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefineddate6"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_6', 'Date 6')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefineddate7"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_7', 'Date 7')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefineddate8"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_8', 'Date 8')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefineddate9"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_9', 'Date 9')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefineddate10"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDDATE_10', 'Date 10')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedcomment"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDCOMMENT', 'User Defined Comment')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedquantity1"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_1', 'Quantity 1')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedquantity2"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_2', 'Quantity 2')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedquantity3"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_3', 'Quantity 3')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedquantity4"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_4', 'Quantity 4')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedquantity5"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_5', 'Quantity 5')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedquantity6"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_6', 'Quantity 6')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedquantity7"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_7', 'Quantity 7')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedquantity8"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_8', 'Quantity 8')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedquantity9"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_9', 'Quantity 9')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="userdefinedquantity10"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDQUANTITY_10', 'Quantity 10')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="plannedreceivedshippeddatetime"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.PLANNEDRECEIVEDSHIPPEDDATETIME', 'Planned Received Shipped D/T')}
                    dataType="date"
                    visible={false}
                    format="MM/dd/yyyy hh:mm:ss aa"
                  ></Column>
                  <Column
                    dataField="container"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.CONTAINER', 'Container #')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="equipmentinterchangereport"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.EQUIPMENTINTERCHANGEREPORT', 'Equip Interchange Report')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="carrier"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.R_CARRIER', 'Carrier #')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="transportCarrier"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.R_TRANSPORTCARRIER', 'Transport Carrier')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="totalNetWeight"
                    caption="Total Net Wt"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="totalGrossWeight"
                    caption="Total Gross Wt"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="consigneeName"
                    caption="Consignee Name"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="carrierName"
                    caption="Carrier Name"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="transportCarrierName"
                    caption="Trans Carrier Name"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="transactiongroup"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.TRANSACTIONGROUP', 'Transaction Group')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="freightchargetype"
                    caption={Localization.formatMessage('WMTRANSACTIONHEADER.FREIGHTCHARGETYPE', 'Freight Charge Type')}
                    visible={false}
                  ></Column>
                  <Column
                    dataField="totalQuantityOrder"
                    caption="Total Order"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="totalQuantityActual"
                    caption="Total Actual"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="consigneeAddress1"
                    caption="Consignee Addr1"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="consigneeAddress2"
                    caption="Consignee Addr2"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="consigneeZip"
                    caption="Consignee Zip"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="consigneeState"
                    caption="Consignee State"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="consigneeAddressMemo"
                    caption="Consignee Addr Memo"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="shipperAddress1"
                    caption="Shipper Addr1"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="shipperAddress2"
                    caption="Shipper Addr2"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="shipperZip"
                    caption="Shipper Zip"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="shipperState"
                    caption="Shipper State"
                    visible={false}
                  ></Column>
                  <Column
                    dataField="shipperAddressMemo"
                    caption="Shipper Addr Memo"
                    visible={false}
                  ></Column>
                  <GridToolbar>
                    <GridToolbarItem location="before">
                      <Button
                        disabled={isEditButtonDisabled} 
                        onClick={handelEditClick}
                        type="default"
                        text="Edit"
                      ></Button>
                    </GridToolbarItem>
                    <GridToolbarItem location="before">
                      <div>
                        <Link to="/wm/transactiondataentry/create-transaction">
                          <Button
                            type="default"
                            className="gridTopButton"
                            text="Create"
                          ></Button>
                        </Link>
                      </div>
                    </GridToolbarItem>
                    <GridToolbarItem name="exportButton" />
                    <GridToolbarItem name="columnChooserButton" />
                  </GridToolbar>
                </DataGrid>
          </div>
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    oidc: state.oidc
  };
}
export default connect(mapStateToProps)(WMTransactionDataEntryList);